import * as T from '../types';

const setSurchargeId = (surchargeId) => {
  return { type: T.SET_SURCHARGE_ID, surchargeId };
};

export default setSurchargeId;
